import * as React from "react";
import * as ReactDOM from "react-dom";
import { dialogContainerElement } from "../../..";
import { E2EIdentifier } from "../../../e2e/E2EIdentifier";
import { Buttons } from "../Common/components/Buttons";
import { generateButtons } from "../Common/components/Buttons.utils";
import { Dialog } from "../Common/components/Dialog";
import { DialogContent } from "../Common/components/DialogContent";
import { Title } from "../Common/components/Title";
import { Wrapper } from "../Common/components/Wrapper";
import { IDialogDesktop } from "./DialogDesktop";

export const DialogDesktopDefaultView = (props: IDialogDesktop) => {
  const {
    message,
    title,
    hideDialog,
    buttons,
    showing,
    cover,
    scrollable,
    centerMessage
  } = props;

  if (!showing) {
    return null;
  }

  const hasButtons = buttons && buttons.length > 0;

  return ReactDOM.createPortal(
    <Wrapper cover={cover}>
      <Dialog data-e2e-id={E2EIdentifier.DIALOG}>
        <Title data-e2e-id={E2EIdentifier.DIALOG_TITLE}>{title}</Title>
        <DialogContent
          message={message}
          centerMessage={centerMessage}
          scrollable={scrollable}
        />
        {hasButtons && (
          <Buttons buttonCount={buttons.length}>
            {generateButtons(buttons, hideDialog)}
          </Buttons>
        )}
      </Dialog>
    </Wrapper>,
    dialogContainerElement
  );
};
